import _implicitStylesheets from "./taskItem.css";
import _implicitScopedStylesheets from "./taskItem.scoped.css?scoped=true";
import _wdsButton from "wds/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="axwp-task-item__left${0}"${2}><div class="axwp-task-item__number-container${0}"${2}><div class="axwp-task-item__number${0}"${2}><span${3}>${"t4"}</span></div></div><div class="axwp-task-item__done${0}"${2}>${"t6"}</div></div>`;
const $fragment2 = parseFragment`<div class="axwp-task-item__title${0}"${2}><h3${3}>${"t2"}</h3></div>`;
const $fragment3 = parseFragment`<div class="axwp-task-item__subtitle${0}"${2}><p${3}>${"t2"}</p></div>`;
const stc0 = {
  classMap: {
    "axwp-task-item__right": true
  },
  key: 3
};
const stc1 = {
  classMap: {
    "axwp-task-item__tags": true
  },
  key: 8
};
const stc2 = {
  attrs: {
    "name": "tags"
  },
  key: 9
};
const stc3 = [];
const stc4 = {
  classMap: {
    "axwp-task-item__toggle": true
  },
  key: 11
};
const stc5 = {
  classMap: {
    "axwp-task-item__content": true
  },
  key: 13
};
const stc6 = {
  attrs: {
    "name": "content"
  },
  key: 14
};
const stc7 = {
  classMap: {
    "axwp-task-item__actions": true
  },
  key: 15
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, s: api_slot, h: api_element, b: api_bind, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.taskItemClass),
    key: 0
  }, [api_static_fragment($fragment1, 2, [api_static_part(4, null, api_dynamic_text($cmp.taskId)), api_static_part(6, null, api_dynamic_text($cmp.taskDoneText))]), api_element("div", stc0, [api_static_fragment($fragment2, 5, [api_static_part(2, null, api_dynamic_text($cmp.title))]), $cmp.hasSubtitle ? api_static_fragment($fragment3, 7, [api_static_part(2, null, api_dynamic_text($cmp.subtitle))]) : null, $cmp.displayBadge ? api_element("div", stc1, [api_slot("tags", stc2, stc3, $slotset)]) : null, api_element("div", {
    className: api_normalize_class_name($cmp.contentClass),
    key: 10
  }, [api_element("span", stc4, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "text": $cmp.toggleText,
      "variant": "tertiary",
      "size": "small",
      "target": "_blank",
      "ariaLive": "polite"
    },
    key: 12,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.toggleOpen))
    }
  })]), api_element("div", stc5, [api_slot("content", stc6, stc3, $slotset), $cmp.hasCta ? api_element("div", stc7, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "href": $cmp.ctaLink,
      "text": $cmp.ctaText,
      "variant": "secondary",
      "target": $cmp.ctaNewTab
    },
    key: 16,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.markComplete))
    }
  })]) : null])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["content", "tags"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-58v53rfmgtr";
tmpl.legacyStylesheetToken = "undefined-_taskItem";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
